<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de identificação (Procedimentos lançados)">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-identificacao/List'

export default {
    components: {List},
}
</script>